import React, { useState, useEffect } from 'react';
import { Icon } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ModuleWrapper } from '../../../Wrappers/ModuleWrapper';
import { Step3Module1Operations } from '../../../../ducks/step3';
import { CustomCheckBox } from '../../../commons/checkbox';
import {
  SearchContainer,
  Subtitle,
  FeaturesContainer,
  SearchBox,
  ListSuggestion,
  Suggestion,
  Pill,
  ShowMore,
  ImgClose,
  PillContainer,
  DropAmenitie,
  ToggleAmenities,
  DropsContainer,
  ListCheckbox
} from './styles';

const AmenitiesSection = props => {
  const { features, featureCategories } = props;
  const [collapse, setCollapse] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [maxPillsLength, setMaxPillsLength] = useState({ max: 12, canOverflow: false });
  const { featureChecks } = features;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    setCollapse(featureCategories);
  }, [featureCategories]);

  const handleChange = val => {
    if (/^[a-zA-ZáéíóúÁÉÍÓÚñÑã´0-9 ]*$/.test(val)) {
      setSearchValue(val);
      if (featureChecks) {
        setSuggestions(
          featureChecks.filter(
            feature =>
              val
                .trim()
                .split(' ')
                .map(value => feature.name.toLowerCase().match(value.toLowerCase()))
                .filter(withVal => withVal).length > 0 && feature.isChecked === false
          )
        );
      }
    }
  };

  const handleSuggestionClick = id => {
    dispatch(Step3Module1Operations.changeFeatureSelection(id));
    document.getElementById('searchBox').value = '';
    setSuggestions([]);
    setSearchValue('');
  };

  const collapseCategory = categoryName => {
    setCollapse(
      collapse.map(c => {
        if (c.categoryName === categoryName) {
          c.isOpen = !c.isOpen;
        }
        return c;
      })
    );
  };

  const measurer = (category, columns) => {
    const selectArray = featureChecks.filter(a => a.categoryId === category.categoryId);
    const height = Math.ceil(selectArray.length / columns) * 40;
    return height;
  };

  const createPillArea = (featuresC, limits) => {
    let count = 0;
    const pills = featuresC.map(fc => {
      if ((count < limits.max || limits.canOverflow) && fc.isChecked) {
        count += 1;
        return (
          <Pill data-repa={`step3-amenities-pillArea-pill-${fc.id}`} key={`pill-${fc.id}`}>
            <span>{fc.name}</span>
            <ImgClose
              data-repa={`step3-amenities-pillArea-pill-${fc.id}-button-delete`}
              onClick={() => dispatch(Step3Module1Operations.changeFeatureSelection(fc.id))}
            >
              <Icon
                data-repa={`step3-amenities-pillArea-pill-${fc.id}-button-icon`}
                name='close'
                width={13}
                height={13}
                viewBox='0 0 24 31'
                stroke='white'
              />
            </ImgClose>
          </Pill>
        );
      }
      return null;
    });
    return pills;
  };

  const handleKeyPress = e => {
    const codigo = e.which || e.keyCode;
    if (codigo === 13) {
      e.preventDefault();
    }
  };

  return (
    <ModuleWrapper data-repa='step3-amenities' title={t('publisher.step3.module1.text')}>
      <FeaturesContainer>
        <Subtitle data-repa='step3-amenities-subtitle'>{t('publisher.step3.module1.addFeatures.title')}</Subtitle>
        <SearchContainer data-repa='step3-amenities-searchBoxContainer'>
          <SearchBox
            data-repa='step3-amenities-searchBox'
            id='searchBox'
            autoComplete='off'
            value={searchValue}
            placeholder={t('publisher.step3.module1.addFeatures.placeholder')}
            onChange={e => handleChange(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <Icon
            data-repa='step3-amenities-searchBoxContainer-icon'
            name='Lupa'
            width={20}
            height={20}
            viewBox='0 0 16 16'
            colorFill='#7c98a7'
          />
          {searchValue && (
            <ListSuggestion data-repa='step3-amenities-suggestionList'>
              {suggestions.length > 0 ? (
                suggestions.map(sf => (
                  <Suggestion
                    data-repa={`step3-amenities-suggestionList-suggestion-${sf.id}`}
                    key={sf.id}
                    onClick={() => handleSuggestionClick(sf.id)}
                  >
                    <span data-repa={`step3-amenities-suggestionList-suggestion-${sf.id}-name`} className='name'>
                      {sf.name}
                    </span>
                    <span
                      data-repa={`step3-amenities-suggestionList-suggestion-${sf.id}-category`}
                      className='category'
                    >
                      {sf.categoryName}
                    </span>
                  </Suggestion>
                ))
              ) : (
                <div data-repa='step3-amenities-suggestionList-suggestion-notFound' className='not-found'>
                  {t('publisher.step3.module1.featureNotFound')}
                </div>
              )}
            </ListSuggestion>
          )}
        </SearchContainer>
        <PillContainer data-repa='step3-amenities-pillArea'>
          {featureChecks && createPillArea(featureChecks, maxPillsLength)}
        </PillContainer>
        <ShowMore
          data-repa='step3-amenities-pillArea-collapseCheck'
          showMe={featureChecks && featureChecks.filter(fe => fe.isChecked).length > maxPillsLength.max}
          onClick={() => setMaxPillsLength({ ...maxPillsLength, canOverflow: !maxPillsLength.canOverflow })}
        >
          {maxPillsLength.canOverflow ? (
            <div data-repa='step3-amenities-pillArea-collapseCheck-less'>
              {t('publisher.step3.module1.addFeatures.btn.less')}
              <Icon name='chevronUp' width={16} height={16} viewBox='0 0 16 16' />
            </div>
          ) : (
            <div data-repa='step3-amenities-pillArea-collapseCheck-more'>
              {t('publisher.step3.module1.addFeatures.btn.more')}
              <Icon name='chevronDown' width={16} height={16} viewBox='0 0 16 16' />
            </div>
          )}
        </ShowMore>
      </FeaturesContainer>
      <DropsContainer data-repa='step3-amenities-categories'>
        {featureCategories &&
          featureCategories.map(category => (
            <DropAmenitie data-repa='step3-amenities-dropAmenitie' key={`category-${category.categoryId}`}>
              <ToggleAmenities
                data-repa={`step3-amenities-categories-category-${category.categoryId}-button-collapse`}
                type='button'
                onClick={() => collapseCategory(category.categoryName)}
              >
                <span data-repa='step3-amenities-dropAmenitie-name'>{category.categoryName}</span>
                <Icon
                  data-repa='step3-amenities-dropAmenitie-icon'
                  name={
                    collapse.some(c => c.categoryId === category.categoryId && c.isOpen) ? 'chevronUp' : 'chevronDown'
                  }
                  width={20}
                  height={20}
                  viewBox='0 0 16 16'
                />
              </ToggleAmenities>
              <ListCheckbox
                data-repa='step3-amenities-listCheckBox'
                showing={collapse.some(c => c.categoryId === category.categoryId && c.isOpen)}
                amenites={measurer(category, 3)}
                amenitesmobile={measurer(category, 2)}
              >
                {featureChecks &&
                  featureChecks.map(fc => {
                    if (fc.categoryId === category.categoryId) {
                      return (
                        <CustomCheckBox
                          width='200px'
                          data-repa={`step3-amenities-customCheck-${fc.id}`}
                          key={`check-${fc.id}`}
                        >
                          <div>
                            <label data-repa={`step3-amenities-customCheck-${fc.id}-label`} htmlFor={`check-${fc.id}`}>
                              <input
                                data-repa={`step3-amenities-categories-category-${category.categoryId}-check-${fc.id}`}
                                type='checkbox'
                                name={`check-${fc.id}`}
                                id={`check-${fc.id}`}
                                checked={fc.isChecked}
                                onChange={() => dispatch(Step3Module1Operations.changeFeatureSelection(fc.id))}
                              />
                              <span data-repa={`step3-amenities-customCheck-${fc.id}-name`}>{fc.name}</span>
                            </label>
                          </div>
                        </CustomCheckBox>
                      );
                    }
                    return null;
                  })}
              </ListCheckbox>
            </DropAmenitie>
          ))}
      </DropsContainer>
    </ModuleWrapper>
  );
};

export { AmenitiesSection };
